module.exports = __webpack_public_path__ + "img/show_cn_text_7.1cdb21ec.png";